
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 27","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"20.482","cy":"13.5","fill":"#E345FF","r":"3.821"}}),_c('path',{attrs:{"fill":"#5935DD","d":"M4.518.332h15.964v26.336H4.518z"}}),_c('path',{attrs:{"d":"M.479 13.533h15.126m0 0L9.808 8.502m5.797 5.03l-5.797 5.032","stroke":"#fff"}})])
          )
        }
      }
    